import React from 'react';
import NextButton from './NextButton';

const VSClue: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>
        Admittedly this next stop might be for me... head over to the place you
        were an ambassador for in college and pick out something fun to wear
        after our dinner.
      </p>
      <img src='hawaii.jpg' />
      <NextButton
        prompt='Text a preview from the changing room to receive the next answer 😉'
        acceptedClues={['wyoming']}
      />
    </div>
  );
};

export default VSClue;
